import styled from 'styled-components'

export const FooterContainer = styled.div`
  margin-top: 15rem;
  width: 100%;
  border-top: 1px solid hsla(0, 0%, 100%, 0.1);
`
export const PageContainer = styled.div`
  padding-right: 5%;
  padding-left: 5%;
  display: flex;
  justify-content: center;
`
export const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  min-height: 14rem;
  border: 1px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
`
